export default __webpack_public_path__ + "static/media/EliteoneLogoWhite.9be03453.png";